import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';
import { isNativePlatform } from '@/utils/capacitor';

const SPLASH_HIDE_FALLBACK_MS = 3000;

export async function disableKeyboardAccessory(): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }
  await Keyboard.setAccessoryBarVisible({ isVisible: false });
}

export async function hideNativeSplash(): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }
  await SplashScreen.hide();
}

export function scheduleHideNativeSplash(): () => void {
  if (!isNativePlatform()) {
    return () => undefined;
  }

  let cancelled = false;
  let fallbackId = 0;
  let frameId = 0;

  const hide = () => {
    if (cancelled) {
      return;
    }
    cancelled = true;
    window.clearTimeout(fallbackId);
    void hideNativeSplash();
  };

  frameId = window.requestAnimationFrame(() => {
    window.requestAnimationFrame(hide);
  });
  fallbackId = window.setTimeout(hide, SPLASH_HIDE_FALLBACK_MS);

  return () => {
    cancelled = true;
    window.cancelAnimationFrame(frameId);
    window.clearTimeout(fallbackId);
  };
}
